import React from 'react';
import { Col, Row, Button, Table, Badge, Spinner } from 'reactstrap';
import AdminPage from '../../components/admin/AdminPage';
import LoadingCard from '../../components/LoadingCard';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useNearByPlaceMetrics } from './hooks/useNearByPlaceMetrics';

const formatDistance = (distanceMt: number | null): string => {
  if (distanceMt === null || distanceMt === undefined) return '—';
  return `${distanceMt.toFixed(0)} m`;
};

const formatTime = (timeSeconds: number | null): string => {
  if (timeSeconds === null || timeSeconds === undefined) return '—';
  return `${timeSeconds}s`;
};

const ProjectNearByPlaceMetrics: React.FC = () => {
  const {
    isLoading,
    loadingTable,
    calculating,
    nearByPlaces,
    handleCalculateMetrics,
    sweetAlert,
    alertProps,
    globalAlertOptions,
  } = useNearByPlaceMetrics();

  const pageName = `Distancias y tiempos de lugares cercanos`;
  const pageParentName = `Preventa`;

  if (isLoading)
    return <LoadingCard name={pageName} parent_name={pageParentName} />;

  return (
    <AdminPage
      name={pageName}
      parentName={pageParentName}
      globalAlertOptions={globalAlertOptions}
    >
      {sweetAlert && (
        <SweetAlert {...alertProps}>
          <div className="text-center" style={{ whiteSpace: 'pre-line' }}>
            {alertProps.text}
          </div>
        </SweetAlert>
      )}

      <Row className="mt-3 mb-3">
        <Col md="12" className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Lugares cercanos del proyecto</h5>
          <Button
            color="primary"
            onClick={handleCalculateMetrics}
            disabled={calculating || nearByPlaces.length === 0}
          >
            {calculating ? (
              <>
                <Spinner size="sm" className="mr-2" />
                {' '}Calculando...
              </>
            ) : (
              <>
                <i className="fas fa-calculator mr-2" />
                {' '}Calcular distancias y tiempos
              </>
            )}
          </Button>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Table className="align-items-center" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Lugar cercano</th>
                <th scope="col">Distancia</th>
                <th scope="col">Tiempo</th>
                <th scope="col">Estado</th>
              </tr>
            </thead>
            <tbody>
              {loadingTable ? (
                <tr>
                  <td colSpan={5} className="text-center">
                    Cargando lugares cercanos...
                  </td>
                </tr>
              ) : nearByPlaces.length > 0 ? (
                nearByPlaces.map((place, index) => (
                  <tr key={place.near_by_place_id}>
                    <td>{index + 1}</td>
                    <td>{place.name}</td>
                    <td>{formatDistance(place.distance_mt)}</td>
                    <td>{formatTime(place.time_seconds)}</td>
                    <td>
                      <Badge
                        color={
                          place.distance_mt !== null &&
                          place.time_seconds !== null
                            ? 'success'
                            : 'warning'
                        }
                      >
                        {place.distance_mt !== null &&
                        place.time_seconds !== null
                          ? 'Calculado'
                          : 'Pendiente'}
                      </Badge>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    No hay lugares cercanos registrados en el proyecto
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </AdminPage>
  );
};

export default ProjectNearByPlaceMetrics;